import type { NavigateFunction } from '~/modules';
import { Routes } from '~/routes';
import type { CreditProductsStore } from '~/stores';
import { PAYMENT_TYPE } from '~/utils';

export const goToHome = (
  creditProducts: CreditProductsStore,
  navigate: NavigateFunction,
) => {
  navigate(`/${creditProducts.qrCodeId}`);
};

export const handleNewCredit = async (
  creditProducts: CreditProductsStore,
  navigate: NavigateFunction,
  setIsLoading: (isLoading: boolean) => void,
) => {
  setIsLoading(true);
  await creditProducts.cancelCreditSimulation();
  creditProducts.setCurrentCreditSimulationRequest({
    paymentType: PAYMENT_TYPE.WITHDRAW,
  });
  await creditProducts.creditSimulation();
  navigate(Routes.CREDIT_SIMULATION_WITHDRAWAL_CONFIRMATION);
  setIsLoading(false);
};

export const goToOnboardingIntro = (navigate: NavigateFunction) => {
  navigate(Routes.ONBOARDING_INTRO);
};
